import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CheckList } from './CheckList';
import type { Bonus } from '../types/content';
interface BonusCardProps {
  bonus: Bonus;
}
export function BonusCard({
  bonus
}: BonusCardProps) {
  return <article className="bg-white rounded-2xl p-6 md:p-10 shadow-[0_20px_40px_rgba(0,0,0,0.18)]" data-id="element-36" data-mp="2t3wroybs89zp">
      <div className="grid lg:grid-cols-[5fr_7fr] gap-8 lg:gap-12" data-id="element-37" data-mp="2x46z8ff838go">
        <div data-id="element-38" data-mp="20f93ouznf6ig">
          <div className="flex items-center gap-3 mb-4" data-id="element-39" data-mp="20fr483tcg6w6">
            <span className="font-display font-black text-orange text-lg" data-id="element-40" data-mp="25dau60zem83y">BONUS {bonus.id}</span>
            <span className="px-2.5 py-0.5 rounded-full bg-seafoam-light text-forest text-xs font-bold border border-seafoam" data-id="element-41" data-mp="29fe9x1t3vyv1">
              FREE
            </span>
          </div>
          <h3 className="text-2xl md:text-3xl font-display font-extrabold text-navy leading-tight mb-3" data-id="element-42" data-mp="2e7p9u4nujknl">
            {bonus.title}
          </h3>
          <p className="text-base text-forest font-semibold leading-snug mb-6" data-id="element-43" data-mp="1loi95f6o9tbn">{bonus.subtitle}</p>
          <div className="space-y-3 text-base text-muted leading-relaxed" data-id="element-44" data-mp="1x13a9g7cff55">
            {bonus.story.map(p => <p key={p} data-id="element-45" data-mp="1s4cu6svjgjjq">{p}</p>)}
          </div>

          {bonus.flow && <ol className="mt-5 flex flex-wrap items-center gap-x-1 gap-y-2" data-id="element-46" data-mp="1nba1so2hzg54">
              {bonus.flow.map((step, i) => <li key={step} className="flex items-center gap-1" data-id="element-47" data-mp="1icyrkc8aj3md" data-mpi={i}>
                  <span className="px-2.5 py-1 rounded-md bg-navy text-white text-xs font-bold uppercase whitespace-nowrap" data-id="element-48" data-mp="1df6w588fszdf">
                    {step}
                  </span>
                  {i < bonus.flow!.length - 1 && <ArrowRight size={14} className="text-seafoam-dark" aria-hidden="true" data-id="element-49" data-mp="14dpl449vznvl" />}
                </li>)}
            </ol>}

          {bonus.levels && <ol className="mt-5 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-2" data-id="element-50" data-mp="2ype20bzoi0im">
              {bonus.levels.map((level, i) => <li key={level} className="rounded-lg border border-seafoam bg-seafoam-light px-3 py-2 text-center" data-id="element-51" data-mp="s2yd3tmty0oq" data-mpi={i}>
                  <span className="block text-orange font-display font-black text-sm" data-id="element-52" data-mp="i5aegsm3s91a">L{i + 1}</span>
                  <span className="block text-forest font-bold text-xs uppercase" data-id="element-53" data-mp="n3vfuvd3cyrb">{level}</span>
                </li>)}
            </ol>}
        </div>

        <div className="flex flex-col gap-8" data-id="element-54" data-mp="1armptsb5szpf">
          {bonus.lists.map(list => <CheckList key={list.label} list={list} data-id="element-55" data-mp="1fs0zfeseshpk" />)}
          <div className="rounded-xl bg-seafoam-light border border-seafoam p-5 mt-auto" data-id="element-56" data-mp="10ui41tl87695">
            <span className="text-forest font-bold block mb-1" data-id="element-57" data-mp="15ttlz5xbwhsb">Result:</span>
            <p className="text-navy text-base font-semibold" data-id="element-58" data-mp="3lm0pjlwjlc9u">{bonus.result}</p>
          </div>
        </div>
      </div>
    </article>;
}